import { Card } from '@/common/ui/Card'
import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon'

type GiftTokensCardProps = {
    hasName?: boolean
    hasLastName?: boolean
    hasPhone?: boolean
    onClaim?: () => void
}

export const GiftTokensCard = ({ hasName, hasLastName, hasPhone, onClaim }: GiftTokensCardProps) => {
    const allFieldsFilled = hasName && hasLastName && hasPhone

    if (allFieldsFilled) {
        return null // Скрываем карточку если все поля заполнены
    }

    return (
        <Card
            className='flex-1'
            style={{
                visibility: 'hidden',
                background: 'linear-gradient(135deg, rgba(145, 97, 237, 0.3) 0%, rgba(190, 150, 255, 0.1) 100%)',
            }}
        >
            <div className='flex flex-col gap-6'>
                <h3 className='text-lg font-medium'>Получите токены в подарок!</h3>
                <p className='text-sm text-pixorion-gray-2'>
                    Заполните данные профиля, чтобы получить{' '}
                    <span className='font-medium text-[#be96ff]'>100 бесплатных токенов</span>
                </p>
                <div className='flex flex-col gap-2'>
                    <div className='flex items-center gap-2'>
                        <Icon
                            name={hasName ? 'tick-circle' : 'danger'}
                            className={`w-[18px] h-[18px] ${hasName ? 'text-white' : 'text-pixorion-gray-2'}`}
                        />
                        <p className={`text-sm ${hasName ? 'text-white' : 'text-pixorion-gray-2'}`}>Имя</p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <Icon
                            name={hasLastName ? 'tick-circle' : 'danger'}
                            className={`w-[18px] h-[18px] ${hasLastName ? 'text-white' : 'text-pixorion-gray-2'}`}
                        />
                        <p className={`text-sm ${hasLastName ? 'text-white' : 'text-pixorion-gray-2'}`}>Фамилия</p>
                    </div>
                    <div className='flex items-center gap-2'>
                        <Icon
                            name={hasPhone ? 'tick-circle' : 'danger'}
                            className={`w-[18px] h-[18px] ${hasPhone ? 'text-white' : 'text-pixorion-gray-2'}`}
                        />
                        <p className={`text-sm ${hasPhone ? 'text-white' : 'text-pixorion-gray-2'}`}>Номер телефона</p>
                    </div>
                </div>
                <div className='flex justify-end pt-4'>
                    {allFieldsFilled ? (
                        <Button emphasis='accent' size='md' className='!h-10' onClick={onClaim}>
                            Получить
                        </Button>
                    ) : (
                        <Button
                            emphasis='secondary'
                            variant='outline'
                            size='md'
                            className='!h-10'
                            as='a'
                            href='/profile'
                        >
                            Заполнить профиль
                        </Button>
                    )}
                </div>
            </div>
        </Card>
    )
}
